import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import SimplePage from '../common/SimplePage';
import { Form, Input, FormRow} from '../common/Forms';
import storagelocationConfig from './config/storagelocationConfig';
import request from '../../helpers/request';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var AddStoragelocation = createReactClass({
  propTypes: {
    newStorageLocationAdded: PropTypes.func.isRequired
  },

  getInitialState(){
    return {
      newStorageLocation: ''
    };
  },

  componentDidMount() {
    this.form.focus('name');
  },

  submitForm(storageLocation) {
    request.post({
      url: storagelocationConfig.apiUrl,
      data: storageLocation,
      success: () => {
        this.form.reset();
        this.props.newStorageLocationAdded();
      }
    });
  },

  render(){
    return (
      <SimplePage title="Neuer Lagerort" icon="inbox">
        <Form ref={c => this.form = c}
          onSubmit={this.submitForm}
          showBackButton={false}
          isAjaxInProgress={this.props.isAjaxInProgress}
          submitButtonTitle="Lagerort hinzufügen">

          <fieldset>
            <FormRow width={6}>
              <Input
                ref={c => this.input = c}
                layout="vertical"
                name="name"
                id="name"
                label="Neuer Lagerort:"
                type="text"
                required
              />
            </FormRow>
          </fieldset>

        </Form>
      </SimplePage>
    );
  }
});

export default AjaxInProgressHOC(AddStoragelocation);



// WEBPACK FOOTER //
// ./src/components/storagelocations/AddStorageLocation.js